<template>
    <div>
        <select class="custom-select base_select" data-width="100%"
                :id="id ? id : field"
                :name="field"
                v-model="form[field]"
                :class="[form.errors.has(field) ? 'is-invalid' : '']"
                :disabled="disabled"
                @change="handleChange"
        >
            <option :value="null" v-if="prompt">{{prompt}}</option>
            <option v-for="item in items" :value="item[value]">{{item[text]}}</option>
        </select>
        <div class="invalid-feedback" v-if="form.errors.has(field)">
            {{form.errors.get(field)}}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: String,
            form: {
                type: Object,
                required: true
            },
            field: {
                type: String,
                required: true
            },
            items: {
                type: Array,
                required: true
            },
            value: String,
            text: String,
            prompt: String,
            disabled: Boolean
        },
        methods: {
            handleChange() {
                this.$emit('change');
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>
